import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import CommonUtil from "../util/CommonUtils";


const PermissionAccess = ({ roleAccess, children }) => {
  const navigate = useNavigate();
  const userRole = CommonUtil.getRoleCode();

  useEffect(() => {
    if (!CommonUtil.isEmptyString(localStorage.getItem("token"))) {
      if (!roleAccess.includes(userRole)) {
        navigate("/page-not-found");
      }
    } else {
      navigate("/")
    }
  }, [userRole]);

  return roleAccess.includes(userRole) ? children : null;
};

export default PermissionAccess;
